import { ConbineEvent } from 'conbine';

/**
 * Configuration event
 * @author  Neil Rackett
 */
export class ConfigEvent extends ConbineEvent {
  public static readonly SCAN_LOCATION_CHANGE: string = 'scanLocationChange';
}
